@if (contentlet$ | async; as contentlet) { @for (content of contentlet.blogContent.content; track content) { @if
(content.identifier) {
<custom-dot-cms-content-render [contentlet]="content" />
} @if (content.type) {
<custom-dot-cms-block-editor-content-render [content]="content" />
} } }
